export default {
      id: "apple_pay-usage",
      viewBox: "0 0 41 20",
      url: __webpack_public_path__ + "sprite.svg#apple_pay",
      toString: function () {
        return this.url;
      }
    }